import { PaginationProps } from '@components/V4/Pagination';
import Table from '@components/V4/Table/Table';
import Tooltip from '@components/V4/Tooltip';
import { ExclamationCircleIcon } from '@heroicons/react/outline';
import moment from 'moment';

type Props = {
  enrollments?: any[];
  isLoading: boolean;
  pagination: PaginationProps;
};

const SessionFeedbackTable = ({ enrollments, isLoading, pagination }: Props) => {
  const rows =
    enrollments?.flatMap((enrollment) =>
      (enrollment.sessionParentFeedback ?? [])
        .filter((feedback: any) => typeof feedback?.parentFeedback?.rating === 'number')
        .map((feedback: any, index: number) => ({
          id: `${enrollment._id}-${feedback.sessionId ?? index}`,
          enrollment,
          feedback,
        }))
    ) ?? [];

  return (
    <section className="relative px-18 mb-20">
      <Table pagination={pagination} isLoading={isLoading} className="mt-1">
        <Table.Header>
          <Table.Row isHeader>
            <Table.HeaderCell>Course</Table.HeaderCell>
            <Table.HeaderCell>Student</Table.HeaderCell>
            <Table.HeaderCell>Mentor</Table.HeaderCell>
            <Table.HeaderCell>Session</Table.HeaderCell>
            <Table.HeaderCell>Submitted</Table.HeaderCell>
            <Table.HeaderCell>Rating</Table.HeaderCell>
            <Table.HeaderCell>Message</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body hasResults={!isLoading && !!rows.length}>
          {rows.map(({ enrollment, feedback }) => (
            <Table.Row key={`${enrollment._id}-${feedback.sessionId}`}>
              <Table.Cell>{enrollment.course?.title ?? 'n/a'}</Table.Cell>
              <Table.Cell>
                <Tooltip text={enrollment.student?.isDeactivated ? 'Deactivated' : undefined}>
                  <span className="flex gap-1">
                    {enrollment.student?.name ?? 'n/a'}{' '}
                    {enrollment.student?.isDeactivated && (
                      <ExclamationCircleIcon className="w-4 h-4" aria-label="Deactivated user" />
                    )}
                  </span>
                </Tooltip>
              </Table.Cell>
              <Table.Cell>
                {feedback.mentor?.fullName ?? enrollment.mentor?.name ?? 'n/a'}
              </Table.Cell>
              <Table.Cell>{feedback?.sessionName ?? 'n/a'}</Table.Cell>
              <Table.Cell>
                {feedback?.parentFeedback?.createdAt
                  ? moment(feedback.parentFeedback.createdAt).format('DD.MM.YYYY')
                  : 'n/a'}
              </Table.Cell>
              <Table.Cell>{feedback?.parentFeedback?.rating ?? 'n/a'}</Table.Cell>
              <Table.Cell className="max-w-72">
                <Tooltip text={feedback?.parentFeedback?.message}>
                  <span className="block truncate">
                    {feedback?.parentFeedback?.message || (
                      <span className="text-customGrey">n/a</span>
                    )}
                  </span>
                </Tooltip>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </section>
  );
};

export default SessionFeedbackTable;
